'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./widget.css');

var WidgetHeader = (function (_React$Component) {
    _inherits(WidgetHeader, _React$Component);

    function WidgetHeader() {
        _classCallCheck(this, WidgetHeader);

        _get(Object.getPrototypeOf(WidgetHeader.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(WidgetHeader, [{
        key: 'render',
        value: function render() {
            var options = this.props.options;

            options = options || {};
            return _react2['default'].createElement(
                'div',
                { className: 'widget-header clearfix' },
                _react2['default'].createElement(
                    'h3',
                    { className: 'widget-header-title' },
                    _react2['default'].createElement('i', { className: 'icon ion-pricetag' }),
                    ' ',
                    _react2['default'].createElement(
                        'span',
                        null,
                        options.title
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'btn-group widget-header-toolbar' },
                    _react2['default'].createElement(
                        'a',
                        { href: 'javascript: void(0)', title: 'Expand/Collapse', className: 'btn btn-link btn-toggle-expand', onClick: this.props.handleClick.bind(this, 'btn-toggle-expand') },
                        _react2['default'].createElement('i', { className: 'icon ion-ios-arrow-up' })
                    ),
                    _react2['default'].createElement(
                        'a',
                        { href: 'javascript: void(0)', title: 'Remove', className: 'btn btn-link btn-remove', onClick: this.props.handleClick.bind(this, 'btn-remove') },
                        _react2['default'].createElement('i', { className: 'icon ion-ios-close-empty' })
                    )
                )
            );
        }
    }]);

    return WidgetHeader;
})(_react2['default'].Component);

var WidgetContent = (function (_React$Component2) {
    _inherits(WidgetContent, _React$Component2);

    function WidgetContent() {
        _classCallCheck(this, WidgetContent);

        _get(Object.getPrototypeOf(WidgetContent.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(WidgetContent, [{
        key: 'render',
        value: function render() {
            var options = this.props.options;

            options = options || {};
            return _react2['default'].createElement(
                'div',
                { className: 'widget-content' },
                options.content
            );
        }
    }]);

    return WidgetContent;
})(_react2['default'].Component);

var WidgetFooter = (function (_React$Component3) {
    _inherits(WidgetFooter, _React$Component3);

    function WidgetFooter() {
        _classCallCheck(this, WidgetFooter);

        _get(Object.getPrototypeOf(WidgetFooter.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(WidgetFooter, [{
        key: 'render',
        value: function render() {
            return _react2['default'].createElement('div', { className: 'widget-footer' });
        }
    }]);

    return WidgetFooter;
})(_react2['default'].Component);

var Widget = (function (_React$Component4) {
    _inherits(Widget, _React$Component4);

    function Widget() {
        _classCallCheck(this, Widget);

        _get(Object.getPrototypeOf(Widget.prototype), 'constructor', this).apply(this, arguments);
    }

    _createClass(Widget, [{
        key: 'handleClick',
        value: function handleClick(target) {
            if (target === 'btn-remove') {
                this.unmount();
            }
        }
    }, {
        key: 'unmount',
        value: function unmount() {
            var container = _react2['default'].findDOMNode(this.refs.widgetContainer);
            _react2['default'].unmountComponentAtNode(container);
            container.remove();
        }
    }, {
        key: 'render',
        value: function render() {
            var options = this.props.options;

            options = options || {};
            options.containerClass = options.containerClass || '';
            return _react2['default'].createElement(
                'div',
                { className: options.containerClass, ref: 'widgetContainer' },
                _react2['default'].createElement(
                    'div',
                    { className: 'widget' },
                    !options.noheader && _react2['default'].createElement(WidgetHeader, { options: options, handleClick: this.handleClick.bind(this) }),
                    _react2['default'].createElement(WidgetContent, { options: options })
                )
            );
        }
    }]);

    return Widget;
})(_react2['default'].Component);

exports.Widget = Widget;
//# sourceMappingURL=data:application/json;base64,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